import { Box, Image, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import Owner from "../assets/pX.jpg";
const Footer = () => {
    return (
        <Box
            bgColor={"blackAlpha.900"}
            color={"whiteAlpha.700"}
            minH={"48"}
            px={"16"}
            py={["16", "8"]}
        >
            <Stack direction={["column", "row"]} h={"full"} alignItems={"center"}>
                <VStack w={"full"} alignItems={["center", "flex-start"]}>
                    <Text fontWeight={"bold"}>About Us</Text>
                    <Text
                        fontSize={"sm"}
                        letterSpacing={"widest"}
                        textAlign={["center", "left"]}
                    >
                        We are the best crypto trading app in India, we provide our guidance
                        at a very reasonable price.
                    </Text>
                </VStack>

                <VStack>
                    <Image
                        borderRadius='full'
                        boxSize='150px'
                        src={Owner}
                        alt='Dan Abramov'
                    />
                    <Text>Our Founder</Text>
                    <Text>Priyank Shah</Text>

                </VStack>
            </Stack>
        </Box>
    );
};

export default Footer;